import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface CommonsState {
  loadingAttachmentId: string | null;
  checkedItemsIds: string[];
  isAllItemsChecked: boolean;
  // To not store thousands of ids if all items checked + manage uncheck
  uncheckedItemsIds: string[];
}

const initialState: CommonsState = {
  loadingAttachmentId: null,
  checkedItemsIds: [],
  isAllItemsChecked: false,
  uncheckedItemsIds: []
};

const commonsSlice = createSlice({
  name: 'commons',
  initialState,
  reducers: {
    setLoadingAttachmentId: (
      state: CommonsState,
      action: PayloadAction<string | null>
    ) => {
      state.loadingAttachmentId = action.payload;
    },

    setCheckedItemsIds: (
      state: CommonsState,
      action: PayloadAction<string[]>
    ) => {
      state.checkedItemsIds = action.payload;
    },

    setUncheckedItemsIds: (
      state: CommonsState,
      action: PayloadAction<string[]>
    ) => {
      state.uncheckedItemsIds = action.payload;
    },

    setIsAllItemsChecked: (
      state: CommonsState,
      action: PayloadAction<boolean>
    ) => {
      state.isAllItemsChecked = action.payload;
    },

    resetCheckedItems: (state: CommonsState) => {
      state.checkedItemsIds = [];
      state.uncheckedItemsIds = [];
      state.isAllItemsChecked = false;
    }
  }
});

export const {
  setLoadingAttachmentId,
  setCheckedItemsIds,
  setIsAllItemsChecked,
  setUncheckedItemsIds,
  resetCheckedItems
} = commonsSlice.actions;

export default commonsSlice.reducer;
